import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';

import { DESKTOP_NAV_GUTTER } from '../../constants';

export const CategoryNavLinksContainer = styled.div`
  width: auto;
  padding: ${SPACER.xlarge} ${SPACER.large};
  margin-left: auto;
`;

export const CategoryNavImageContainer = styled.div`
  margin: ${SPACER.medium} auto ${SPACER.x2large} 0;

  /* Desktop only: ModalMobile reuses this container inside its own gutter.
     :not(:empty) keeps the drop-down centred as before when there is no card. */
  ${MEDIA_QUERIES.xlUp} {
    &:not(:empty) {
      padding-right: ${DESKTOP_NAV_GUTTER};
    }
  }

  /* width/height on the img reserve space while it loads; height:auto keeps
     it proportional if those flag values drift from the real ratio. */
  img {
    height: auto;
  }

  ${MEDIA_QUERIES.xxlUp} {
    min-width: 300px;
  }
`;
